/* Nova PDP – film (click-to-play YouTube) and photo reel lightbox. See sections/nova-pdp.liquid */
(function () {
  function init(root) {
    if (root.dataset.nvSocialReady) return;
    root.dataset.nvSocialReady = '1';

    // Click-to-play: the YouTube player only loads when the visitor asks for it.
    root.querySelectorAll('[data-nv-film]').forEach(function (frame) {
      var btn = frame.querySelector('.nv-film__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = frame.dataset.id;
        if (!id) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        btn.remove();
        iframe.focus();
      });
    });

    // Photo reel lightbox
    var dialog = root.querySelector('[data-nv-lightbox-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      var img = dialog.querySelector('[data-nv-lightbox-img]');
      root.querySelectorAll('[data-nv-lightbox]').forEach(function (b) {
        b.addEventListener('click', function () {
          img.src = b.dataset.nvLightbox;
          img.alt = b.dataset.alt || '';
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.hasAttribute('data-nv-lightbox-close')) dialog.close(); });
      dialog.addEventListener('close', function () { img.src = ''; });
    }
  }

  document.querySelectorAll('[data-nv]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nv]').forEach(init);
  });
})();
